import { CloudUploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Flex, Popconfirm } from "antd";

import { useAsyncAction, useQueueInfo } from "@/hooks";
import { useResetApp } from "@/hooks/app/useResetApp";
import { useAppDispatch, useOfflineModeSelector } from "@/hooks/redux";
import { StyledInfoBlock, StyledProfileCard } from "@/pages/Profile/styles";
import { BaseButton, PrimaryText } from "@/shared/ui";
import { saveProgressToServerThunk } from "@/store/thunks";

export const ProgressSyncBlock = () => {
    const offlineMode = useOfflineModeSelector();

    const { isRunning: isRunningQueue } = useQueueInfo();

    const dispatch = useAppDispatch();

    const [handleSaveProgress, saveProgressLoading] = useAsyncAction(
        async () => {
            await dispatch(saveProgressToServerThunk());
        },
    );

    const { handleReset, resetLoading } = useResetApp();

    const disableAction = offlineMode || isRunningQueue;

    return (
        <StyledProfileCard>
            <StyledInfoBlock>
                <PrimaryText fontSize={16} fontWeight="500">
                    Синхронізація даних
                </PrimaryText>

                <Flex vertical gap={12}>
                    <BaseButton
                        icon={<CloudUploadOutlined />}
                        type="primary"
                        onClick={handleSaveProgress}
                        disabled={disableAction}
                        style={{ width: "100%" }}
                        size="large"
                        loading={saveProgressLoading}
                    >
                        Відправити на сервер
                    </BaseButton>

                    <Popconfirm
                        title="Ви впевнені що хочете скинути кеш?"
                        onConfirm={handleReset}
                        disabled={offlineMode}
                        okText="Так"
                        cancelText="Ні"
                    >
                        <BaseButton
                            icon={<DownloadOutlined />}
                            type="primary"
                            disabled={disableAction}
                            loading={resetLoading}
                            style={{ width: "100%" }}
                            size="large"
                        >
                            Завантажити на пристрій
                        </BaseButton>
                    </Popconfirm>
                </Flex>
            </StyledInfoBlock>
        </StyledProfileCard>
    );
};
